export const filterKey = (filter: any) => JSON.stringify(filter);
